import React from 'react';

import './index.scss';

const Playground = () => {
  return <div>Hello Marko</div>;
};

export default Playground;
